// src/icons/svgs/text-direction-ltr.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var SvgTextDirectionLtr = (props, ref) => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, viewBox: "0 0 24 24", ref, ...props, children: [
  /* @__PURE__ */ jsx("path", { stroke: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ jsx("path", { d: "M5 19h14M17 21l2-2-2-2M16 4H9.5a3.5 3.5 0 0 0 0 7h.5M14 15V4M10 15V4" })
] });
var ForwardRef = forwardRef(SvgTextDirectionLtr);
var text_direction_ltr_default = ForwardRef;
export {
  text_direction_ltr_default as TextDirectionLTR
};
